import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Box, IconButton, Avatar, Button, Grid, Tooltip, Stack } from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import PropTypes from "prop-types";
import CropperModal from '../../../components/Cropper/CropperModal';
import { API_URL } from '../../../appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { RiErrorWarningLine } from 'react-icons/ri';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTMutation } from '../../../utils/useTMutation';
import showToast from '../../../components/Hot-Toast/showToast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "./ProfileCard.css";
import { setLastChatUser } from '../../../slice/chatWindowSlice';
import CustomSwal from '../../../components/SwalPopup/customSwal';
import SliderModal from '../../../components/DialogPopup/SliderModal';
import { socket } from '../../../clientSocket/socketService';
import { formatDateAndTime, formatDateAndTimeUTC, formatLocalDateTime, isValidUUID } from '../../../utils/genericMethod';
import { ScheduleInterview } from '../../../components/DialogPopup/ScheduleInterview';
import { setSelectedTabData } from '../../../slice/profileTabSectionSlice';

const formatName = (data) => {
    if (!data) {
        return { initials: '' };
    }
    const roleName = data.ROLE_NAME || '';
    const initials = roleName
        .split(' ')
        .map(word => word.charAt(0).toUpperCase())
        .join('');
    return initials;
};

const ProfileCard = ({ data, selectedTab, setSelectedTab, customTab }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { selectedTabData } = useSelector((state) => state.profileTabSection);
    const { ID, JOBID } = useParams();
    const validID = ID ? isValidUUID(ID) : false;
    const validJobId = JOBID ? isValidUUID(JOBID) : false;
    const refs = new URLSearchParams(useLocation().search).get('refs');
    const { controlBy, controlAction, userDetails, jobData } = useSelector(state => state.user);
    const FacilityID = userDetails?.USER_TYPE === 'facility' ? userDetails?.ID : null;
    const clinicianJobStatus = selectedTabData?.about?.clinicianJobStatus || data?.about?.clinicianJobStatus;
    const interviewDateTime = selectedTabData?.about?.interviewDateTime || data?.about?.interviewDateTime;

    const appliedJob = data?.about?.appliedJob;
    const ViewProfileImage = (controlBy === 'admin' || controlBy === 'facility') && controlAction === 'view';
    const initials = formatName(data?.about);
    const inputRef = useRef(null);
    const inputRef1 = useRef(null);
    const [src, setSrc] = useState(null);
    const [preview, setPreview] = useState(null);

    const [previewCover, setPreviewCover] = useState(null);
    const [srcCover, setSrcCover] = useState(null);
    const [openSlider, setOpenSlider] = useState(false);
    const [sliderValue, setSliderValue] = useState(10);
    const [action, setAction] = useState(null);
    const [note, setNote] = useState('');

    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpenCover, setModalOpenCover] = useState(false);
    const [profileCoverImageUrl, setProfileCoverImageUrl] = useState(null);
    const [profileImageUrl, setProfileImageUrl] = useState(null);

    const { mutateAsync } = useTMutation("/job/saveAndRemoveJob", "post", (response) => {
        if (response.STATUS) {
            return response;
        }
    });
    const [open, setOpen] = useState(false);

    const handleSchedule = async (data) => {
        console.log("🔥  Interview Scheduled:", data?.interviewDate, data?.interviewTime);
        // Format both date and time in local timezone to prevent mismatch
        data.interviewDate = formatLocalDateTime(data.interviewDate);
        data.interviewDateTime = formatLocalDateTime(data.interviewTime);
        console.log("🕗 interviewDate:", data.interviewDate, "interviewDateTime:", data.interviewDateTime);

        let response = await mutateAsync({ STATUS: "Interview", USER_ID: ID, JOB_ID: JOBID, SELECTED_JOB_ID: jobData?.ID, USER_TYPE: 'facility', ...data, });
        if (response.STATUS) {
            const updatedTabData = {
                ...selectedTabData,
                about: {
                    ...selectedTabData.about,
                    interviewDateTime: response.OUTPUT
                }
            }
            dispatch(setSelectedTabData(updatedTabData));

            // Invalidate the clinician listing cache to force refresh
            queryClient.invalidateQueries(['fetchFacilityClinician']);

            setOpen(false);
            // Redirect to Interview tab after successful scheduling with refresh trigger
            setTimeout(() => {
                navigate('/facility/clinicians?tab=Interview&refresh=true');
            }, 1000);
        }
        showToast(response.STATUS ? "success" : "error", response.MESSAGE, 3000);

    };
    useEffect(() => {
        if (data?.about) {
            if (data?.about?.PROFILE_IMAGE_PATH) {

                setProfileImageUrl(API_URL + "user/viewFile?fileName=" + data?.about?.PROFILE_IMAGE_PATH);
            }
            if (data?.about?.PROFILE_COVER_IMAGE_PATH) {
                setProfileCoverImageUrl(API_URL + "user/viewFile?fileName=" + data?.about?.PROFILE_COVER_IMAGE_PATH);
            }
        }
    }, [data?.about?.PROFILE_IMAGE_PATH, data?.about?.PROFILE_COVER_IMAGE_PATH]);
    const DisputedTab = data?.disputedTab;
    const tabs = [
        'About', 'License', 'Work Experience', 'Specialties', 'Qualification & Language', 'Certifications',
        'Essential Documents', 'Trainings', 'Verify Profile', 'Bank Details', 'Received Payments', 'Miscellaneous Documents'
    ];

    // const filteredTabs = customTab ? customTab : (controlBy === "admin") ? tabs.filter(tab => tab !== 'Bank Details') : tabs.filter(tab => tab !== 'Verify Profile' && tab !== 'Miscellaneous Documents');
    const filteredTabs = customTab ? customTab : (controlBy === "admin") ? tabs : tabs.filter(tab => tab !== 'Verify Profile');

    const handleInputClick = (e) => {
        e.preventDefault();
        if (controlAction !== 'view') {
            inputRef.current.click();
        }
    };

    const handleInputClickCover = (e) => {
        e.preventDefault();
        if (controlAction !== 'view') {
            inputRef1.current.click();
        }
    };
    const handleImgChange = (e) => {
        const file = e.target.files[0];

        if (file && file.size < 5 * 1024 * 1024) {
            setSrc(URL.createObjectURL(file));
            setModalOpen(true);
        } else {
            alert("Please select an image smaller than 5MB.");
        }
    };
    const handleCoverImgChange = async (e) => {
        const file = e.target.files[0];

        if (file && file.size < 5 * 1024 * 1024) {
            setSrcCover(URL.createObjectURL(file));
            setModalOpenCover(true);
        } else {
            alert("Please select an image smaller than 5MB.");
        }
    };
    const handleCancel = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        setModalOpen(false);
    };
    const handleCoverCancel = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        setModalOpenCover(false);
    };



    const handleHiredAndSettleRate = () => {
        CustomSwal({
            title: "Set Clinician Pay Rate for the job",
            text: "The clinician has been selected for the role, but before finalizing their status as 'Hired,' please set the pay rate for this clinician.",
            footer: `If you want to Hired in above Pay Rate, please press the Confirm button. else close the process without saving`,
            onConfirm: handleOpenSlider,
            onCancel: handleCancel,
            confirmButtonText: "Confirm & Set Pay Rate",
            cancelButtonText: "Cancel",
            customClass: {
                confirmButton: 'custom-swal-confirm', // Custom class for confirm button
                cancelButton: 'custom-swal-cancel',   // Custom class for cancel button (optional)
            },
        });

    }
    const handleSubmit = async (val, data = null) => {
        // let response = await mutateAsync({ STATUS: val, USER_ID: ID, JOB_ID: JOBID })
        let response = await mutateAsync({ STATUS: val, USER_ID: ID, JOB_ID: JOBID, SELECTED_JOB_ID: jobData?.ID, USER_TYPE: 'facility', ...data });
        if (response.STATUS) {
            showToast("success", response.MESSAGE, 3000);
            navigate(-1);

        } else {
            showToast("error", response.MESSAGE, 3000);
        }
    }
    const handleMessage = async () => {
        if (data?.about) {
            const clinicianID = data.about?.USER_ID;

            // First: Initiate and wait for confirmation
            socket.emit('initiate_register_clinician', { clinicianId: clinicianID, facilityId: FacilityID }, (initResponse) => {
                if (initResponse?.status === 'success') {
                    // Now safely join the room
                    socket.emit('joinRoom', { facilityId: FacilityID, clinicianId: clinicianID }, (response) => {
                        if (response?.status === 'success') {
                            const dataForMessage = {
                                clinicianID,
                                roomId: response.roomId,
                                dp: data.about?.PROFILE_IMAGE_PATH,
                                roleID: data.about?.JOBROLE_ID,
                                clinicianName: data.about?.FULL_NAME,
                                profileStatus: data.about?.PROFILE_STATUS,
                                clinicianState: data.about?.STATE,
                                roleName: data.about?.ROLE_NAME
                            };
                            dispatch(setLastChatUser(dataForMessage));
                            navigate(`/facility/messages/inbox`);
                        } else {
                            console.error('Failed to join room:', response?.message);
                        }
                    });
                } else {
                    console.error('Clinician registration failed:', initResponse?.message);
                }
            });
        }
    };


    ////////////////////SLIDER FXN CODE BELOW //////////////////////////////////////////////////////////////////////////////////////////////////////



    const handleOpenSlider = () => {
        setSliderValue(sliderConfig.initialValue || sliderConfig.min); // Reset sliderValue
        setOpenSlider(true);
    };
    const handleCloseSlider = () => {
        setOpenSlider(false);
        setAction(null); // Reset action
        setNote(''); // Reset note
    };
    const handleSliderChange = useCallback((event, newValue) => {
        setSliderValue(newValue); // Update parent state
    }, []);

    const handleAction = useCallback(async (actionType) => {
        setAction(actionType);
        handleSubmit("Hired", { appliedJobID: appliedJob?.ID, note, actionType, sliderValue });
        // await approvalMutation.mutateAsync({ ID, note, actionType, sliderValue });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID, note, sliderValue]);

    const handleNoteChange = useCallback((event) => {
        setNote(event.target.value);
    }, []);

    const sliderConfig = useMemo(() => ({
        min: appliedJob?.PAY_AMOUNT_FROM || 0,
        max: appliedJob?.PAY_AMOUNT_TO,
        step: 0.1,
        initialValue: appliedJob?.PAY_AMOUNT_FROM
    }), [appliedJob?.PAY_AMOUNT_FROM, appliedJob?.PAY_AMOUNT_TO]);

    return (
        <Card sx={{

            padding: "0px !important",
            borderRadius: "0px 0px 8px 8px !important",
            marginTop: 2
        }}>
            <div style={{ position: 'relative', top: "-5px" }}>
                <CardMedia
                    component="img"
                    height="200"
                    image={previewCover || profileCoverImageUrl ||
                        "https://singlecolorimage.com/get/eeeeee/600x400"
                    }
                    //     sx={{
                    //     objectFit: "contain",
                    //     width: "1022px",
                    //     height: "200px",
                    //     backgroundColor: "#f5f5f5",
                    //     borderRadius: "8px",
                    //   }}
                    alt="Card image"
                    className='card-images'
                />
                {ViewProfileImage ?
                    (
                        <Box

                            sx={{
                                position: 'relative',
                                top: 10,
                                left: 110,
                                padding: .5,
                                height: 24,
                                width: 24,
                                backgroundColor: 'transparent',
                                borderRadius: '50%',
                                color: '#ccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                        </Box>
                    )
                    : (
                        <>
                            <Tooltip title="Upload Cover Image">
                                <IconButton
                                    sx={{
                                        color: 'linear-gradient(#6ebe44,#4eb3e8)',
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        height: 18,
                                        width: 18,
                                        backgroundColor: 'white',
                                        padding: 2,
                                        cursor: 'pointer'
                                    }}
                                >
                                    <CameraAltOutlinedIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Upload Cover Image">
                                <IconButton
                                    sx={{
                                        color: 'linear-gradient(#6ebe44,#4eb3e8)',
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        height: 18,
                                        width: 18,
                                        backgroundColor: 'white',
                                        padding: 2,
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleInputClickCover}
                                >
                                    <CameraAltOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <input
                                type="file"
                                accept="image/*"
                                ref={inputRef1}
                                onChange={handleCoverImgChange}
                                hidden
                            />
                        </>
                    )}
                {/* Profile Picture */}
                <Avatar
                    src={preview || profileImageUrl}
                    modalOpen={modalOpen}
                    setPreview={setPreview}
                    setModalOpen={setModalOpen}
                    sx={{
                        position: 'absolute',
                        top: 150,
                        left: 15,
                        width: 120,
                        height: 120,
                        border: '3px solid white'
                    }}
                />
                {!ViewProfileImage && (
                    <Tooltip title="Upload Profile Image">
                        <IconButton>
                            <CameraAltOutlinedIcon
                                sx={{
                                    position: 'relative',
                                    top: 10,
                                    left: 98,
                                    padding: .5,
                                    height: 24,
                                    width: 24,
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    color: 'linear-gradient(#6ebe44,#4eb3e8)',
                                    cursor: 'pointer'
                                }}
                                onClick={handleInputClick}
                            />
                        </IconButton>
                    </Tooltip>
                )}
                <input
                    type="file"
                    accept="image/*"
                    ref={inputRef}
                    onChange={handleImgChange}
                    hidden
                />

                {/* Ends of Profile Picture */}
            </div>

            <CardContent sx={{ mt: 2 }}>
                <Grid display={"flex"}>
                    <Grid >
                        <Typography className='profileName'>{data?.about?.FULL_NAME}</Typography>
                        <Typography variant="body2" className='profileRole' color="text.secondary" mt={0.5}>{data?.about?.ROLE_NAME && `${data.about.ROLE_NAME}${initials ? ` (${initials})` : ''}`}
                        </Typography>
                    </Grid>

                    {controlBy === 'facility' &&
                        <Grid ml="auto">
                            {(refs === 'msg_clinician' && !validJobId) ? null : (
                                clinicianJobStatus !== "Hired" && (
                                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                                        {clinicianJobStatus === "Interview" ? (
                                            <Button variant="outlined" color="primary" onClick={() => setOpen(true)} >{`Interview Scheduled on ${formatDateAndTimeUTC(interviewDateTime)}`} </Button>
                                        )
                                            :
                                            (<Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => setOpen(true)}
                                            >
                                                Schedule Interview
                                            </Button>
                                            )}

                                        {clinicianJobStatus !== "Rejected" && (
                                            <Button
                                                onClick={() => handleSubmit("Rejected")}
                                                variant="outlined"
                                                color="error"
                                            >
                                                Reject
                                            </Button>
                                        )}

                                        {clinicianJobStatus !== "Under Review" && (
                                            <Button
                                                onClick={() => handleSubmit("Under Review")}
                                                variant="outlined"
                                                color="secondary"
                                            >
                                                Under Review
                                            </Button>
                                        )}

                                        <Button
                                            onClick={() =>
                                                appliedJob.HIRING_TYPE === "Request Hire"
                                                    ? handleSubmit("Hired")
                                                    : handleHiredAndSettleRate()
                                            }
                                            variant="outlined"
                                            color="success"
                                        >
                                            Confirm Applicant
                                        </Button>


                                        <Button variant='contained' color="success" onClick={handleMessage}>Message</Button>
                                    </Stack>
                                )
                            )}


                        </Grid>
                    }
                </Grid>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'left',
                        gap: "16px", // Adjust spacing between items
                        padding: "0px 5px",
                        mt: 2,

                        '@media (max-width: 600px)': {
                            flexDirection: 'column', // Stack tabs vertically on small screens
                            alignItems: 'center',
                        }
                    }}
                >
                    {filteredTabs.map((tab) => (
                        <Box
                            key={tab}
                            sx={{
                                position: 'relative',
                                padding: '2px 2px',

                                cursor: 'pointer',
                                color: "#6ebe44",
                                '@media (max-width: 600px)': {
                                    width: '100%',
                                    textAlign: 'center'
                                }
                            }}
                            onClick={() => setSelectedTab(tab)}
                        >
                            <Typography
                                className={`custom-typography ${selectedTab === tab ? 'active-tab' : ''}`}
                                variant="body2"
                                color={selectedTab === tab ? 'success' : 'textSecondary'}
                                sx={{ fontWeight: 'bold' }}
                            >
                                {tab}
                                {(DisputedTab && DisputedTab.some(disputedTab => disputedTab.TabName === tab)) &&
                                    <span>
                                        <span data-tooltip-id="addAdditionalTooltip1" style={{ display: "inline-block", cursor: 'pointer', paddingLeft: '3px' }}>
                                            <RiErrorWarningLine color="#EA4933" />
                                        </span>

                                        {!ViewProfileImage && <ReactTooltip
                                            id="addAdditionalTooltip1"
                                            place="top"
                                            content={

                                                <span style={{ background: "#000000", color: "#ffffff", opacity: "70%", padding: 4, borderRadius: "4px" }}>You have pending to upload documents</span>


                                            }
                                            style={{
                                                backgroundColor: 'white',
                                                color: 'red',
                                                // border: '1px solid red',
                                                fontSize: '0.75rem',

                                            }} />}

                                    </span>

                                }
                            </Typography>
                            {selectedTab === tab && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        bottom: 12,
                                        left: 0,
                                        right: 0,
                                        height: '2px',
                                        backgroundColor: '#6ebe44',
                                    }}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
            </CardContent>
            {open && <ScheduleInterview open={open} onClose={() => setOpen(false)} onSubmit={handleSchedule} interviewDateTime={interviewDateTime || ""} />}
            {modalOpen && <CropperModal
                src={src}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setPreview={setPreview}
                handleCancel={handleCancel}
                propsData={{
                    directory: "profileImage",
                    ID: data?.about?.ID, USER_TYPE: data?.about?.USER_TYPE
                }}
            />}
            {modalOpenCover && <CropperModal
                src={srcCover}
                modalOpen={modalOpenCover}
                setModalOpen={setModalOpenCover}
                setPreview={setPreviewCover}
                handleCancel={handleCoverCancel}
                propsData={{
                    directory: "profileImageCover",
                    ID: data?.about?.ID, USER_TYPE: data?.about?.USER_TYPE
                }}
            />}

            {
                openSlider && <SliderModal
                    open={openSlider}
                    onClose={handleCloseSlider}
                    title="Set a Pay Rate (rate/hr)"
                    sliderConfig={sliderConfig}
                    sliderValue={sliderValue}
                    onSliderChange={handleSliderChange}
                    action={action}
                    onAction={handleAction}
                    note={note}
                    onNoteChange={handleNoteChange}
                />
            }
        </Card>
    );
};

export default ProfileCard;

ProfileCard.propTypes = {
    data: PropTypes.object.isRequired,
    selectedTab: PropTypes.string.isRequired,
    setSelectedTab: PropTypes.func.isRequired,
};
